import { render, staticRenderFns } from "./MerchantProfile.vue?vue&type=template&id=7426e03b&"
import script from "./MerchantProfile.vue?vue&type=script&lang=js&"
export * from "./MerchantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports